import React from 'react'
import { useLocation } from 'react-router-dom'

import CreateUser from '../../../components/CreateUser'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  const query = new URLSearchParams(useLocation().search)
  const organizationId = parseInt(query.get('organizationId'))

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Create a new user</h1>}></ContextMenu>
      <CreateUser organizationId={organizationId} />
    </div>
  )
}
